<div class="server-settings-root">
	<h1 style="margin-bottom: 20px;">ninjaOne&reg; Settings</h1>
	<form [formGroup]="form">
		<div class="form-group row mb-3">
			<div>
				<input type="checkbox" [formControl]="enabled" />
				<span class="uv-checkbox-label">Enable ninjaOne&reg;</span>
			</div>
		</div>
		<div class="mb-3 row" [ngClass]="{'has-error':form.hasError('noneOrAllSettings') && !serverURL.value}">
			<span class="col-lg-2">Server URL:</span>
			<div class="col-lg-5">
				<input class="form-control" type="text" [formControl]="serverURL" />
			</div>
		</div>
		<div class="mb-3 row" [ngClass]="{'has-error':form.hasError('noneOrAllSettings') && !clientID.value}">
			<span class="col-lg-2">Client ID:</span>
			<div class="col-lg-5">
				<input class="form-control" type="password" [formControl]="clientID" />
			</div>
		</div>
		<div class="mb-3 row" [ngClass]="{'has-error':form.hasError('noneOrAllSettings') && !clientSecret.value}">
			<span class="col-lg-2">Client Secret:</span>
			<div class="col-lg-5">
				<input class="form-control" type="password" [formControl]="clientSecret" (keydown)="onClientSecretKeyDownHandler($event)"/>
			</div>
		</div>
		<div class="ninja-one-default-settings-divider"></div>
		<button pButton (click)="onSave()" [disabled]="!form.dirty" label="Save ninjaOne Default Settings"></button>
		<div class="ninja-one-default-settings-divider"></div>
	</form>
</div>